import { defineStore } from 'pinia'
import type { OrderFilters } from '@/types/order'

// NOTE: Filters must be cleared on full browser refresh.
// We intentionally do NOT persist this store to `localStorage`.
const STORAGE_KEY = 'efashion_orders_filters_v1'

export interface OrdersStoreState {
  filters: OrderFilters | null
  savedAt?: number
}

const defaultState = (): OrdersStoreState => ({
  filters: null,
  savedAt: Date.now()
})

function loadFromStorage(): OrdersStoreState {
  // Clear any legacy persisted filters (auto-clear on refresh)
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
  return defaultState()
}

function saveToStorage(_state: OrdersStoreState) {
  // Do not persist filters between page loads.
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}

export const useOrdersStore = defineStore('orders', {
  state: () => loadFromStorage(),
  
  getters: {
    hasFilters: (state): boolean => {
      if (!state.filters) return false
      return Object.values(state.filters).some(value => 
        value !== null && value !== undefined && value !== ''
      )
    }
  },
  
  actions: {
    setFilters(filters: OrderFilters | null) {
      this.filters = filters ? { ...filters } : null
      saveToStorage(this.$state)
    },
    
    clearFilters() {
      this.filters = null
      saveToStorage(this.$state)
    },
    
    persistNow() {
      saveToStorage(this.$state)
    }
  }
})

